<template>
  <div :class="$country === 'ru' ? 'wrapper-ru' : 'wrapper'">
    <WrapperHeader/>
    <Version/>
    <div class='content' v-if="$country === 'ru'">
      <MainPanel
        v-for="(jackpot, index) in jackpotsReversed"
        :key="jackpot.price"
        :price="jackpot.price"
        :sum="jackpot.fg_sum"
        :index="index"
      />
    </div>
    <div class='content' v-else-if="$country === 'kz'">
      <KZMainPanel
        v-for="jackpot in $store.state.jackpots"
        :key="jackpot.price"
        :price="jackpot.price"
        :sum="jackpot.fg_sum"
      />
    </div>
    <WrapperStatus/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainPanel from '@/components/Panel/RU/MainPanel.vue';
import KZMainPanel from '@/components/Panel/KZ/KZMainPanel.vue';
import WrapperHeader from '@/components/Header/WrapperHeader.vue';
import WrapperStatus from '@/components/Status/WrapperStatus.vue';
import Version from '@/components/Version/Version.vue';

export default {
  name: 'Dashboard',
  components: {
    MainPanel,
    KZMainPanel,
    WrapperHeader,
    WrapperStatus,
    Version,
  },
  computed: {
    ...mapGetters(['jackpotsReversed']),
  },
};
</script>

<style scoped>
.wrapper {
  display: grid;
}
.wrapper-ru {
  position: absolute;
  top: 41px;
  left: 100px;
}
.content {
  padding-bottom: 1.6rem;
}
</style>
